import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEraser20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconEraser20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m11.14 3.262 2.063 2.063-4.91 4.91L6.23 8.174zm-1.787 8.034 4.911-4.91L16.38 8.5l-4.911 4.91zM5.17 9.234l-1.904 1.904a1 1 0 0 0 0 1.414l3.823 3.824a1 1 0 0 0 1.415 0l1.904-1.904zm5.972-8.093L12.2 2.2l5.24 5.24L18.5 8.5l-1.06 1.06-7.877 7.877a2.5 2.5 0 0 1-3.535 0l-3.824-3.824a2.5 2.5 0 0 1 0-3.536l7.876-7.876zM12.75 16.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEraser20);
